import { graphql, useStaticQuery } from 'gatsby'

export const query = graphql`
  query {
    localSearchProducts {
      index
      store
    }
  }
`

export const useProductSearchStore = () => {
  const { localSearchProducts } = useStaticQuery(query)
  return localSearchProducts
}
